import { useEffect, useRef, useState } from 'react'
import { ReactModalWrapper, Toggler, TogglerIcon, ToolbarButton } from './Styled'
import Draggable from 'react-draggable'
import useScreenOrientation from 'hooks/useScreenOrientation'
import themeAssetgameToolbarHomeSvg from '@theme/game/toolbar-home.svg'
import themeAssetgameToolbarDepositSvg from '@theme/game/toolbar-deposit.svg'
import themeAssetgameToolbarServiceSvg from '@theme/game/toolbar-service.svg'
import themeAssetgameToolbarCloseSvg from '@theme/game/toolbar-close.svg'

interface ToolbarProps {
  onLobbyClick: () => void
  onDepositClick: () => void
  onServiceClick: () => void
  direction?: number
}

export default function Toolbar({ onLobbyClick, onDepositClick, onServiceClick, direction }: ToolbarProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const style = {
    overlay: {
      zIndex: 10,
      background: 'rgba(0,0,0,0.5)',
    },
  }

  const [isDragging, setIsDragging] = useState<boolean>(false)
  const [position, setPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 })
  const [dragTimeout, setDragTimeout] = useState<ReturnType<typeof setTimeout> | null>(null)
  const { rotateClassName } = useScreenOrientation(direction)
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  function open() {
    setIsOpen(true)
  }

  function onMouseUp(e: React.PointerEvent) {
    if (dragTimeout) {
      clearTimeout(dragTimeout)
    }
    if (!isDragging) {
      e.stopPropagation()
      open()
    }
  }

  function onMouseDown() {
    setIsDragging(false)
    const ko = setTimeout(() => {
      setIsDragging(true)
      setDragTimeout(null)
    }, 200)
    setDragTimeout(ko)
  }

  function handleButtonClick(callback: () => void) {
    setIsOpen(false)
    callback()
  }

  useEffect(() => {
    const onResize = () => {
      setPosition({ x: 0, y: 0 })
    }
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <>
      <Draggable position={position} onDrag={(e, data) => setPosition({ x: data.x, y: data.y })} nodeRef={triggerRef}>
        <Toggler className={rotateClassName} onPointerDown={onMouseDown} onPointerUp={onMouseUp} ref={triggerRef}>
          <TogglerIcon className={rotateClassName}></TogglerIcon>
        </Toggler>
      </Draggable>
      <ReactModalWrapper isOpen={isOpen} style={style} className={'no-focus-outline ' + rotateClassName}>
        <ToolbarButton onClick={() => handleButtonClick(onLobbyClick)}>
          <img src={themeAssetgameToolbarHomeSvg} alt=""></img>
          <div>返回大厅</div>
        </ToolbarButton>
        <ToolbarButton onClick={() => handleButtonClick(onDepositClick)}>
          <img src={themeAssetgameToolbarDepositSvg} alt=""></img>
          <div>存款</div>
        </ToolbarButton>
        <ToolbarButton onClick={() => onServiceClick()}>
          <img src={themeAssetgameToolbarServiceSvg} alt=""></img>
          <div>客服</div>
        </ToolbarButton>
        <ToolbarButton onClick={() => setIsOpen(false)}>
          <img src={themeAssetgameToolbarCloseSvg} alt=""></img>
          <div>关闭</div>
        </ToolbarButton>
      </ReactModalWrapper>
    </>
  )
}
